import { Outlet } from 'react-router-dom'

import ClientDetailNavigation from '../ClientDetailNavigation'

const ClientDetailBody = () => {
  return (
    <div className="flex-1 flex flex-col rounded-[16px] border border-light_gray_3 overflow-hidden">
      <ClientDetailNavigation />
      <Outlet />
    </div>
  )
}

export default ClientDetailBody
